module.exports = __webpack_public_path__ + "static/antd-icon-outlined-265e615808b91899151ad9b0f651954a.png";